"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _styles = require("@material-ui/core/styles");
var _Book = _interopRequireDefault(require("./Book.js"));
var _Journal = _interopRequireDefault(require("./Journal.js"));
var _Web = _interopRequireDefault(require("./Web.js"));
var _Dissertation = _interopRequireDefault(require("./Dissertation.js"));
var _Lecture = _interopRequireDefault(require("./Lecture.js"));
var __jsx = _react.default.createElement;
// import mockData from './Reference.mock.js';

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {
      lineHeight: '1.6em',
      '& .aem-ms-reference-item': {
        display: 'flex',
        fontSize: '12px',
        lineHeight: '1.25em',
        marginBottom: '1rem'
      },
      '& .aem-ms-reference-item-index': {
        display: 'block',
        paddingRight: '0.25em'
      }
    }
  };
});

// interface Author {
// 	firstName?: string
// 	middleInitial?: string
// 	lastName?: string
// }

// interface Reference {
// 	id: string
// 	type: string
// 	authors: Author[]
// 	year: string
// 	title: string
// 	edition: string
// 	publicationPlace: string
// 	publisher: string
// 	publishDate: Date
// 	dateAccessed: Date
//  conference: string
// 	journal: string
// 	volume: string
// 	issue: string
// 	pages: string
// 	url: string
// }

// interface Reference {
//   title: String
//   references: Reference[]
// }

/**
 * Default Edit configuration for the Text component that interact with the Core Text component and sub-types
 *
 * @type EditConfig
 */
var EditConfig = {
  emptyLabel: 'Reference',
  isEmpty: function isEmpty(props) {
    return !props || !props.references || !props.references.length;
  }
};
function renderReference(ref) {
  switch (ref.type) {
    case 'book':
      return __jsx(_Book.default, ref);
    case 'journal':
      return __jsx(_Journal.default, ref);
    case 'web':
      return __jsx(_Web.default, ref);
    case 'dissertation':
      return __jsx(_Dissertation.default, ref);
    case 'lecture':
      return __jsx(_Lecture.default, ref);
    default:
      return null;
  }
}
var Reference = function Reference(props) {
  var styles = useStyles();
  var headline = props.headline,
    references = props.references,
    startNumber = props.startNumber;
  if (!references || !references.length) return __jsx("div", null);
  var offset = parseInt(startNumber) || 1;
  return __jsx(_Box.default, {
    id: props.anchorId,
    className: (headline && "aem-ms-cmp ") + "aem-ms-reference ".concat(styles.root)
  }, headline && __jsx("h3", {
    dangerouslySetInnerHTML: {
      __html: headline
    }
  }), references.map(function (r, index) {
    return __jsx("div", {
      key: r.id || index,
      className: "aem-ms-reference-item"
    }, __jsx("span", {
      className: "aem-ms-reference-item-index",
      dangerouslySetInnerHTML: {
        __html: "".concat(index + offset, ".")
      }
    }), renderReference(r));
  }));
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/reference')(Reference, EditConfig);
exports.default = _default;